/*
 * custom-cart-drawer.js
 * ---------------------------------------------------------------------------
 * Las secciones custom (-pix, main__product, collection-page-grid, etc.) usan
 * formularios HTML planos:  <form action="/cart/add" class="direct-add-to-cart">
 * Un submit plano provoca un POST de navegador y redirige a /cart.
 *
 * Este interceptor captura ese submit, agrega el producto vía AJAX (/cart/add.js)
 * y abre el <cart-drawer> nativo de Dawn con renderContents(), igual que hace
 * product-form.js para los <product-form>. No toca el markup de las secciones.
 *
 * Dependencias globales (cargadas antes por global.js / pubsub.js):
 *   - fetchConfig, routes, publish, PUB_SUB_EVENTS
 * ---------------------------------------------------------------------------
 */
(function () {
  const FORM_SELECTOR = '.direct-add-to-cart, .card_atc_form';

  document.addEventListener('submit', function (event) {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    const cartDrawer = document.querySelector('cart-drawer');

    // Sin drawer en la página o el custom element todavía no se "upgradeó":
    // dejamos que el navegador haga el submit normal (fallback a /cart).
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

    event.preventDefault();

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    // Pedimos a Shopify que devuelva el HTML renderizado de las secciones del
    // drawer (drawer + burbuja del ícono) para refrescarlas sin recargar.
    formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cartDrawer.setActiveElement(document.activeElement);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        // response.status presente => error (ej: sin stock). No redirigimos.
        if (response.status) {
          if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'custom-cart-drawer',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          return;
        }

        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'custom-cart-drawer',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }

        // is-empty bloquea el drawer cuando el carrito arrancó vacío.
        if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');

        // Refresca el contenido del drawer Y lo abre (renderContents llama a open()).
        cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error('[custom-cart-drawer] add to cart failed:', error);
        // Ante un fallo inesperado, no dejamos al usuario trabado: vamos a /cart.
        window.location = routes.cart_url;
      })
      .finally(() => {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
      });
  });
})();
